import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faBan,
  faCar,
  faChartSimple,
  faCircleQuestion,
  faDatabase,
  faEdit,
  faFire,
  faLayerGroup,
  faList,
  faPerson,
  faServer,
  faSitemap,
  faSquarePollVertical,
  faStar,
  faTable,
  faTv
} from '@fortawesome/free-solid-svg-icons';
import {filter, Subject, takeUntil} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {ApiService} from '../../services/api.service';
import {RoleService} from '../../services/role.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    imports: [CommonModule, FontAwesomeModule]
})
export class SidebarComponent implements OnDestroy {
  activeLink: string = '';
  @Input() open: boolean = true;
  isSuperUser: boolean = false;
  isAdmin: boolean = false;
    canAccessVisionConfiguration: boolean = false;
    canAccessVisionOperations: boolean = false;
    canAccessDeviceHealth: boolean = false;
  isSalesManager: boolean = false;
  canAccessSubscriptions: boolean = false;
  canAccessLeadManagement: boolean = false;
  showMainDashboard: boolean = true;
  showCoreOps: boolean = true;
    canAccessHelpSupport: boolean = true;
  visitorManagementEnabled: boolean = false;
  subscriptionFeatureEnabled: boolean = true;
  visitorsOpen: boolean = false;
  leadManagementOpen: boolean = false;
  role: string = '';
  private readonly destroy$ = new Subject<void>();

  @Output() linkClicked = new EventEmitter<void>();

  // @Input() isMobile = false;
  // @Input() isSidebarOpen = false;
  // @Input() toggleSidebar: () => void = () => {};


  constructor(
    private router: Router,
    private auth: AuthService,
    private apiService: ApiService,
    private roleService: RoleService,
    library: FaIconLibrary
  ) {
      library.addIcons(faDatabase,
        faCar,
        faServer,
        faChartSimple,
        faCircleQuestion,
        faSquarePollVertical,
        faBan,
        faPerson,
        faSitemap,
        faStar,
        faFire,
        faTv,
        faEdit,
        faList,
        faLayerGroup,
        faTable)
      
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.setActiveLink(this.router.url);
      });
    }
  
    setActiveLink(url: string) {
      this.leadManagementOpen = url.includes('/lead-management/');
      this.visitorsOpen = url.includes('/visitor-management/');

      // Update your active link logic here
      if (url.includes('/lead-management/dashboard')) {
        this.activeLink = 'lead-dashboard';
      } else if (url.includes('/lead-management/leads')) {
        this.activeLink = 'lead-list';
      } else if (url.includes('/lead-management/follow-ups')) {
        this.activeLink = 'lead-follow-ups';
      } else if (url.includes('/lead-management/demo-schedule')) {
        this.activeLink = 'lead-demo-schedule';
      } else if (url.includes('/dashboard')) {
        this.activeLink = 'dashboard';
      } else if (url.includes('/reports')) {
        this.activeLink = 'reports';
      } else if (url.includes('/blacked-vehicle') || url.includes('/add-vehicle-black-list')) {
        this.activeLink = 'blacked-vehicle';
      } else if (url.includes('/view-hotlist') || url.includes('/add-hotlist')) {
        this.activeLink = 'view-hotlist';
      } else if (
        url.includes('/vehicle-monitoring')
        || url.includes('/vehicle-alert-rules')
        || url.includes('/add-vehicle-monitoring')
        || url.includes('/add-vehicle-alert')
        || url.includes('/edit-vehicle-monitoring')
        || url.includes('/edit-vehicle-alert')
      ) {
        this.activeLink = 'vehicle-monitoring';
      } else if (url.includes('/vehicle') || url.includes('/add-vehicle') || url.includes('/vehicle/bulk')) {
        this.activeLink = 'vehicle';
      } else if (url.includes('/track')) {
        this.activeLink = 'track';
      } else if (url.includes('/vision-configuration')) {
          this.activeLink = 'vision-configuration';
      } else if (
          (url.includes('/organization') || url.includes('/signup'))
          && !url.includes('/vision-configuration')
      ) {
          this.activeLink = 'organization';
      } else if (url.includes('/alert')) {
        this.activeLink = 'alert';
      } else if (url.includes('/analytics')) {
        this.activeLink = 'analytics';
      } else if (url.includes('/login-activity')) {
        this.activeLink = 'login-activity';
      } else if (url.includes('/logs')) {
        this.activeLink = 'logs';
      } else if (url.includes('/admin/partners')) {
        this.activeLink = 'partners';
      } else if (url.includes('/admin/sales-installation-partners')) {
        this.activeLink = 'sales-installation-partners';
      } else if (url.includes('/admin/contact-us-requests')) {
          this.activeLink = 'contact-us-requests';
      } else if (url.includes('/admin/initial-occupancy-upload')) {
          this.activeLink = 'initial-occupancy-upload';
      } else if (url.includes('/admin/api-keys')) {
        this.activeLink = 'api-keys';
      } else if (url.includes('/subscriptions')) {
        this.activeLink = 'subscriptions';
      } else if (url.includes('/visitor-management/registers')) {
        this.activeLink = 'visitor-registers';
      } else if (url.includes('/visitor-management/clusters')) {
        this.activeLink = 'visitor-clusters';
      } else if (url.includes('/visitor-management/entries')) {
        this.activeLink = 'visitor-entries';
      } else if (url.includes('/visitor-management/select-register') || url.includes('/visitor-management/entry')) {
        this.activeLink = 'visitor-submit';
      } else if (url.includes('/operations')) {
          this.activeLink = 'operations';
      } else if (url.includes('/device-health')) {
          this.activeLink = 'device-health';
      }
    }
    ngOnInit() {
        this.setActiveLink(this.router.url);
      const userInfo = this.auth.getCurrentUserInfo();
      const groups = Array.isArray(userInfo?.role) ? userInfo.role : [userInfo?.role].filter(Boolean);
      this.role = groups[0] || '';
        this.isSuperUser = this.auth.isSuperUser();
      this.isAdmin = this.roleService.isAdmin(groups) || this.isSuperUser;
        this.canAccessVisionConfiguration = this.roleService.canAccessVisionConfiguration(groups);
        this.canAccessVisionOperations = this.roleService.canAccessVisionOperations(groups);
        this.canAccessDeviceHealth = this.roleService.canAccessDeviceHealth(groups);
      this.isSalesManager = this.roleService.isSalesManager(groups);
      this.subscriptionFeatureEnabled = userInfo?.subscription_enabled !== false;
      this.canAccessSubscriptions = this.roleService.canAccessSubscriptions(groups) &&
          (this.isSuperUser || this.isSalesManager || this.subscriptionFeatureEnabled);
      this.canAccessLeadManagement = this.roleService.canAccessLeadManagement(groups);
      this.showMainDashboard = this.roleService.showMainDashboard(groups);
      this.showCoreOps = this.roleService.canAccessCoreOps(groups);
        this.canAccessHelpSupport = this.roleService.canAccessHelpSupport(groups);
      if (!this.isSuperUser) {
        this.apiService.getAlertDirections().subscribe({
          next: (response: any) => {
            this.visitorManagementEnabled = !!response?.visitor_management_enabled;
            this.subscriptionFeatureEnabled = response?.subscription_enabled !== false;
            this.canAccessSubscriptions = this.roleService.canAccessSubscriptions(groups) &&
                (this.isSuperUser || this.isSalesManager || this.subscriptionFeatureEnabled);
          },
          error: () => {
            this.visitorManagementEnabled = false;
            this.subscriptionFeatureEnabled = userInfo?.subscription_enabled !== false;
            this.canAccessSubscriptions = this.roleService.canAccessSubscriptions(groups) &&
                (this.isSuperUser || this.isSalesManager || this.subscriptionFeatureEnabled);
          }
        });
      }
    }

    get visitorManagementVisible(): boolean {
      return this.showCoreOps && this.visitorManagementEnabled;
    }
    // toggleSidebar() {
    //   this.isMinimized = !this.isMinimized;
    // }
  
  
    navigate(route: string) {
      
      this.activeLink = route;
      // localStorage.setItem('activeLink', this.activeLink);
      this.router.navigate([route]);
    //   if (this.isMobile && this.toggleSidebar) {
    //   this.toggleSidebar(); // Close sidebar after navigating on mobile
    // }
    }
  
    toggleVisitors() {
      this.visitorsOpen = !this.visitorsOpen;
    }

    toggleLeadManagement() {
      this.leadManagementOpen = !this.leadManagementOpen;
    }

    clearActiveLink() {
      this.activeLink = '';
    }

    onLinkClick() {
      this.linkClicked.emit();
    }
    changeOrganizationPic(){
      
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    
    // @HostListener('document:click', ['$event'])
    // clickOutside(event: Event) {
    //   const target = event.target as HTMLElement;
    //   const modalElement = document.querySelector('.modal-content');
    //   if (modalElement && !modalElement.contains(target)) {
    //     // this.showReason = false;
    //   }
    // }

  //   navigate(route: string) {
  //   this.router.navigate([route]);
  //   if (this.isMobile && this.toggleSidebar) {
  //     this.toggleSidebar(); // Close sidebar after navigating on mobile
  //   }
  // }
}
